import { Component, OnInit } from '@angular/core';
import { MultioComponent } from 'src/app/components/multio/multio.component';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-change-coin',
  templateUrl: './change-coin.component.html',
  styleUrls: ['./change-coin.component.scss'],
})
export class ChangeCoinComponent implements OnInit {
  public multimonedaIcon: string = './assets/icons/moneda.svg';

  constructor(private uiSv: UiServices, public paramSv: ParamServicesService) {}

  ngOnInit() {}

  changeCoin(ev) {
    this.uiSv.showPopover(MultioComponent, {}, '', undefined);
  }
}
